import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  FormControl,
} from "react-bootstrap";
import TableData from "./component/tableData";
import { get, updateToken } from "../../../helpers/api_helper";
import { useSelector } from "react-redux";
import add_new from "../../../Assets/svg/add_new.svg";
import AddNewSecondaryPlanet from "./component/Modal/AddNewSecondaryPlanet";
import Pagination from "../../../components/Pagination";
import useCheckPermission from "../../../hooks/useCheckPermission";

const SecondaryPlanet = () => {
  const token = useSelector((state) => state.login.token);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [secondaryPlanet, setSecondaryPlanet] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const fetchSecondaryPlanet = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const skip = page;
        const response = await get(
          `/planet/secondary?skip=${skip}&limit=${itemsPerPage}&search=${debouncedSearchQuery}`
        );
        if (response?.success) {
          setSecondaryPlanet(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 1);
        } else {
          console.log("Failed to fetch secondary planet");
          setSecondaryPlanet([]);
        }
      } catch (error) {
        console.log(error);
        setSecondaryPlanet([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage, debouncedSearchQuery]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchSecondaryPlanet(currentPage);
    }
  }, [token, fetchSecondaryPlanet, currentPage]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleAddSecondaryPlanet = () => {
    setModalMode("create");
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      <AddNewSecondaryPlanet
        showModal={showModal}
        setShowModal={setShowModal}
        handleDataRefresh={() => fetchSecondaryPlanet(currentPage)}
        mode={modalMode}
        resetFormOnClose={showModal}
      />

      <section className="userSec position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h5 className="m-0 fw-sbold">Secondary Planets Details</h5>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  <FormControl
                    type="text"
                    placeholder="Search secondary planets"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="rounded-pill"
                    style={{ width: "200px" }}
                  />
                  {useCheckPermission("secondaryPlanet", "CREATE") && <Button
                    onClick={handleAddSecondaryPlanet}
                    className="d-flex align-items-center justify-content-center rounded-pill"
                  >
                    Add Secondary Planet
                    <span className="icn ms-2">
                      <img src={add_new} alt="" />
                    </span>
                  </Button>}
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2 scrollable-table-container">
              <div className="commonTable scrollable-table-container">
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100px" }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : secondaryPlanet.length > 0 ? (
                  <>
                    <TableData
                      secondaryPlanet={secondaryPlanet}
                      setRefresh={() => fetchSecondaryPlanet(currentPage)}
                    />
                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </>
                ) : (
                  <div className="d-flex justify-content-center align-items-center my-5">
                    <p>No secondary planet data available.</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SecondaryPlanet;
